import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';

// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import { authSelector, load } from './slices/auth';

// ----------------------------------------------------------------------

export default function App() {
  const { isAuthenticated } = useSelector(authSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(load());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeConfig>
      <ScrollToTop />
      <GlobalStyles />
      <BaseOptionChartStyle />
      <Router isLoggedIn={isAuthenticated} />
    </ThemeConfig>
  );
}
